'use strict';

import type { IndConnection } from '../../Entities/Ind/IndConnection';
import { EntityCollection } from '../EntityCollection';

export class IndConnectionCollection extends EntityCollection<IndConnection> {}
